import React from 'react';
import FlashLoader from '../FlashLoader';
import {
  activeVideoCleared,
  activeVideoSet,
  selectActiveVideo,
  selectVideos,
} from '../../slices/videos/videosSlice';
import { useDispatch, useSelector } from 'react-redux';
import { selectCurrentUser } from '../../slices/user/userSlice';
import VideoPage from '../Videos/VideoPage';
import { Video } from '../../types/Video';
import videoDarkThumbnail from '../../assets/images/video-dark-thumbnail.png';
import videoLightThumbnail from '../../assets/images/video-light-thumbnail.png';
import {
  isLoadingPhase,
  selectStudyPhase,
} from '../../slices/study/studySlice';
import { useSystemTheme } from '../../hooks/useSystemTheme';

const VideoStudy: React.FC = () => {
  const currentUser = useSelector(selectCurrentUser);
  const videos = useSelector(selectVideos);
  const activeVideo = useSelector(selectActiveVideo);
  const studyPhase = useSelector(selectStudyPhase);

  const systemTheme = useSystemTheme();
  const dispatch = useDispatch();

  const setActiveVideo = (video: Video | null) => {
    if (video) {
      dispatch(activeVideoSet(video.id));
    } else {
      dispatch(activeVideoCleared());
    }
  };

  const getThumbnail = () => {
    if (
      currentUser &&
      (currentUser.theme === 'dark' ||
        (currentUser.theme === 'system' && systemTheme === 'dark'))
    ) {
      return videoDarkThumbnail;
    }
    return videoLightThumbnail;
  };

  if (!activeVideo) {
    return <div>No video selected</div>;
  }

  return (
    <>
      <VideoPage
        video={activeVideo}
        setActiveVideo={setActiveVideo}
        upNextVideos={videos.filter(
          (video) =>
            video.watchState !== 'COMPLETED' && video.id !== activeVideo.id
        )}
        getThumbnail={getThumbnail}
        videosViewedInSequence={[]}
        setVideosViewedInSequence={() => {}}
      />
      <FlashLoader visible={isLoadingPhase(studyPhase)} />
    </>
  );
};

export default VideoStudy;
